import { useEffect, useState } from 'react'
import {
    Box,
    Card,
    Grid,
    Toolbar,
    IconButton,
    Typography,
    Button,
    TextField,
    Select,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    FormControl,
    InputLabel,
    Divider,
    Stack,
    TableSortLabel
} from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/free-solid-svg-icons'
import { useMachineContext, useMasterData, useStatus } from '../../context'
import AssignTypeDialog from '../../dialogs/AssignTypeDialog'
import NuevaMaquinaDialog from '../../dialogs/NuevaMaquinaDialog'
import { GenerationStatusModal } from '../../dialogs/StatusModal'

const MachinesAdminPage = ({ roles }) => {
    const { setStatus } = useStatus()
    const { imagenesGenericasOfLine } = useMasterData()
    const { machines, machinesOfProject, nuevaMaquina, editarMaquina, borrarMaquina, asignarTipoMaquina, tipoMaquinas, sumarTipoMaquina, marcasMaquinas, sumarMarcaMaquina, modelosMaquinas, sumarModeloMaquina } = useMachineContext()
    const { getMachines } = useMachineContext()
    const [assignDialogOpen, setAssignDialogOpen] = useState(false)
    const [open, setOpen] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [maquinaParEditar, setMaquinaParaEditar] = useState()
    const [nuevoTipoMaquina, setNuevoTipoMaquina] = useState('')
    const [nuevaMarcaMaquina, setNuevaMarcaMaquina] = useState('')
    const [nuevoModeloMaqina, setNuevoModeloMaquina] = useState('')
    const [nuevoModeloMarcaMaqina, setNuevoModeloMarcaMaquina] = useState('')
    const [order, setOrder] = useState('asc')
    const [orderBy, setOrderBy] = useState('machineId')
    const navigate = useNavigate()

    useEffect(() => {
        getMachines()
        scrollingBottomTiposMaquinas()
        scrollingBottomMarcasMaquinas()
        scrollingBottomModelosMaquinas()
    }, [])

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc'
        setOrder(isAsc ? 'desc' : 'asc')
        setOrderBy(property)
    }

    const stableSort = (array, comparator) => {
        const stabilizedThis = array.map((el, index) => [el, index])
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0])
            if (order !== 0) return order
            return a[1] - b[1]
        })
        return stabilizedThis.map((el) => el[0])
    }

    const descendingComparator = (a, b, orderBy) => {
        let valA = a[orderBy]
        let valB = b[orderBy]

        if (orderBy === 'modelo') {
            valA = a.modelo || a.model || ''
            valB = b.modelo || b.model || ''
        }

        if (orderBy === 'machineId') {
            const numA = Number(valA) || 0
            const numB = Number(valB) || 0
            if (numB < numA) return -1
            if (numB > numA) return 1
            return 0
        }

        const stringA = String(valA || '').toUpperCase()
        const stringB = String(valB || '').toUpperCase()

        if (stringB < stringA) return -1
        if (stringB > stringA) return 1
        return 0
    }

    const getComparator = (order, orderBy) => {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy)
    }

    const openAssignDialog = () => {
        setAssignDialogOpen(true)
    }

    const closeAssignDialog = () => {
        setAssignDialogOpen(false)
    }

    const abrirEditarMaquina = (maquina) => {
        setMaquinaParaEditar(maquina)
        setOpen(true)
        setIsEdit(true)
    }

    const onClose = () => {
        setOpen(false)
        setIsEdit(false)
        setMaquinaParaEditar(null)
    }

    const scrollingBottomTiposMaquinas = () => {
        const element = document.getElementById('tiposMaquinas')
        element.scrollTop = element.scrollHeight
    }

    const scrollingBottomMarcasMaquinas = () => {
        const element = document.getElementById('marcasMaquinas')
        element.scrollTop = element.scrollHeight
    }

    const scrollingBottomModelosMaquinas = () => {
        const element = document.getElementById('modelosMaquinas')
        element.scrollTop = element.scrollHeight
    }

    const handleNuevaMaquina = async (machineData) => {
        try {
            const response = await nuevaMaquina(machineData)
            if (response) {
                setStatus({
                    status: 'completed',
                    title: 'Máquina Creada',
                    message: `La máquina "${machineData.brand} ${machineData.model}" se ha creado con éxito.`,
                    severity: 'success',
                    errorDetails: null
                })
                return response
            }
        } catch (error) {
            console.error('Error al crear máquina:', error)
            const code = error.response?.status || '500'
            const info = Array.isArray(error.response?.data?.message)
                ? error.response?.data?.message.join(', ')
                : (error.response?.data?.message || error.message || 'Error desconocido al crear máquina.')
            setStatus({
                status: 'error',
                title: 'Error al Crear Máquina',
                message: 'No se pudo crear la máquina.',
                severity: 'error',
                errorDetails: { code, info }
            })
        }
    }

    const handleEditarMaquina = async (machineData) => {
        try {
            const response = await editarMaquina(machineData)
            if (response) {
                setStatus({
                    status: 'completed',
                    title: 'Máquina Actualizada',
                    message: `Los cambios para "${machineData.brand} ${machineData.model}" se guardaron con éxito.`,
                    severity: 'success',
                    errorDetails: null
                })
                return response
            }
        } catch (error) {
            console.error('Error al editar máquina:', error)
            const code = error.response?.status || '500'
            const info = Array.isArray(error.response?.data?.message)
                ? error.response?.data?.message.join(', ')
                : (error.response?.data?.message || error.message || 'Error desconocido al actualizar máquina.')
            setStatus({
                status: 'error',
                title: 'Error al Actualizar Máquina',
                message: 'No se pudieron guardar los cambios de la máquina.',
                severity: 'error',
                errorDetails: { code, info }
            })
        }
    }

    const handleAsignarTipoMaquina = async (machineOfProjectId, typeId) => {
        try {
            const response = await asignarTipoMaquina(machineOfProjectId, typeId)
            if (response) {
                setStatus({
                    status: 'completed',
                    title: 'Tipo Asignado',
                    message: 'El tipo de máquina ha sido asignado correctamente.',
                    severity: 'success',
                    errorDetails: null
                })
                return response
            }
        } catch (error) {
            console.error('Error al asignar tipo:', error)
            const code = error.response?.status || '500'
            const info = Array.isArray(error.response?.data?.message)
                ? error.response?.data?.message.join(', ')
                : (error.response?.data?.message || error.message || 'Error desconocido al asignar tipo.')
            setStatus({
                status: 'error',
                title: 'Error al Asignar Tipo',
                message: 'No se pudo asignar el tipo a la máquina.',
                severity: 'error',
                errorDetails: { code, info }
            })
        }
    }

    const nuevoTipo = async () => {
        if (nuevoTipoMaquina.length > 0) {
            if (confirm(`Se agregará el tipo ${nuevoTipoMaquina.toUpperCase()}`)) {
                try {
                    const response = await sumarTipoMaquina(nuevoTipoMaquina)
                    if (response) {
                        setNuevoTipoMaquina('')
                        scrollingBottomTiposMaquinas()
                        setStatus({
                            status: 'completed',
                            title: 'Tipo Creado',
                            message: `Se añadió el tipo de máquina "${nuevoTipoMaquina.toUpperCase()}".`,
                            severity: 'success',
                            errorDetails: null
                        })
                    }
                } catch (error) {
                    console.error('Error al crear tipo:', error)
                    const code = error.response?.status || '500'
                    const info = Array.isArray(error.response?.data?.message)
                        ? error.response?.data?.message.join(', ')
                        : (error.response?.data?.message || error.message || 'Error desconocido al agregar tipo.')
                    setStatus({
                        status: 'error',
                        title: 'Error al Crear Tipo',
                        message: 'No se pudo registrar el nuevo tipo de máquina.',
                        severity: 'error',
                        errorDetails: { code, info }
                    })
                }
            }
        }
    }

    const nuevaMarca = async () => {
        if (nuevaMarcaMaquina.length > 0) {
            if (confirm(`Se agregará marca ${nuevaMarcaMaquina.toUpperCase()}`)) {
                try {
                    const response = await sumarMarcaMaquina(nuevaMarcaMaquina)
                    if (response) {
                        setNuevaMarcaMaquina('')
                        scrollingBottomMarcasMaquinas()
                        setStatus({
                            status: 'completed',
                            title: 'Marca Creada',
                            message: `Se añadió la marca "${nuevaMarcaMaquina.toUpperCase()}".`,
                            severity: 'success',
                            errorDetails: null
                        })
                    }
                } catch (error) {
                    console.error('Error al crear marca:', error)
                    const code = error.response?.status || '500'
                    const info = Array.isArray(error.response?.data?.message)
                        ? error.response?.data?.message.join(', ')
                        : (error.response?.data?.message || error.message || 'Error desconocido al agregar marca.')
                    setStatus({
                        status: 'error',
                        title: 'Error al Crear Marca',
                        message: 'No se pudo registrar la nueva marca de máquina.',
                        severity: 'error',
                        errorDetails: { code, info }
                    })
                }
            }
        }
    }

    const nuevoModelo = async () => {
        if ((nuevoModeloMaqina.length > 0) && (nuevoModeloMarcaMaqina.length > 0)) {
            if (confirm(`Se agregará modelo ${nuevoModeloMaqina.toUpperCase()} de marca ${marcaDesdeId(nuevoModeloMarcaMaqina)}`)) {
                try {
                    const response = await sumarModeloMaquina(nuevoModeloMarcaMaqina, nuevoModeloMaqina)
                    if (response) {
                        setNuevoModeloMaquina('')
                        setNuevoModeloMarcaMaquina('')
                        scrollingBottomModelosMaquinas()
                        setStatus({
                            status: 'completed',
                            title: 'Modelo Creado',
                            message: `Se añadió el modelo "${nuevoModeloMaqina.toUpperCase()}".`,
                            severity: 'success',
                            errorDetails: null
                        })
                    }
                } catch (error) {
                    console.error('Error al crear modelo:', error)
                    const code = error.response?.status || '500'
                    const info = Array.isArray(error.response?.data?.message)
                        ? error.response?.data?.message.join(', ')
                        : (error.response?.data?.message || error.message || 'Error desconocido al agregar modelo.')
                    setStatus({
                        status: 'error',
                        title: 'Error al Crear Modelo',
                        message: 'No se pudo registrar el nuevo modelo de máquina.',
                        severity: 'error',
                        errorDetails: { code, info }
                    })
                }
            }
        }
    }

    const marcaDesdeId = (id) => {
        const value = marcasMaquinas.filter(m => {
            if (id === m._id) return true
            return false
        })
        if (value.length > 0) {
            return value[0].marca
        } else {
            return null
        }
    }

    const handleDelete = async (machine) => {
        if (window.confirm(`¿Está seguro que desea borrar la máquina ${machine.brand} - ${machine.modelo}? Esta acción no se puede deshacer.`)) {
            try {
                const response = await borrarMaquina(machine._id)
                if (response) {
                    setStatus({
                        status: 'completed',
                        title: 'Máquina Eliminada',
                        message: `La máquina "${machine.brand} - ${machine.modelo}" ha sido eliminada.`,
                        severity: 'success',
                        errorDetails: null
                    })
                }
            } catch (error) {
                console.error('Error al eliminar máquina:', error)
                const code = error.response?.status || '500'
                const info = Array.isArray(error.response?.data?.message)
                    ? error.response?.data?.message.join(', ')
                    : (error.response?.data?.message || error.message || 'Error desconocido al eliminar máquina.')
                setStatus({
                    status: 'error',
                    title: 'Error al Eliminar Máquina',
                    message: 'No se pudo eliminar la máquina seleccionada.',
                    severity: 'error',
                    errorDetails: { code, info }
                })
            }
        }
    }

    return (
        <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
            <Grid container spacing={2}>
                {/* Header Section */}
                <Grid item xs={12}>
                    <Paper elevation={0} sx={{ p: 1, bgcolor: '#F9F9F9', borderRadius: 2 }}>
                        <Toolbar variant="dense" sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton
                                    onClick={() => setTimeout(() => navigate(-1), 500)}
                                    size="small"
                                    sx={{ mr: 1 }}
                                >
                                    <ArrowBackIos sx={{ fontSize: 16 }} />
                                </IconButton>
                                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                                    Administración / Máquinas
                                </Typography>
                            </Box>
                            <Button
                                variant="contained"
                                startIcon={<FontAwesomeIcon icon={faTruck} />}
                                onClick={openAssignDialog}
                                sx={{
                                    bgcolor: '#be2e26',
                                    '&:hover': { bgcolor: '#a02620' },
                                    borderRadius: 8,
                                    textTransform: 'none',
                                    px: 3
                                }}
                            >
                                Asignar Tipo a Máquina
                            </Button>
                        </Toolbar>
                    </Paper>
                </Grid>

                {/* Main Content */}
                <Grid item xs={12} lg={7}>
                    <TableContainer component={Paper} elevation={1} sx={{ height: 'calc(100vh - 180px)', borderRadius: 2 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <TableSortLabel
                                            active={orderBy === 'machineId'}
                                            direction={orderBy === 'machineId' ? order : 'asc'}
                                            onClick={() => handleRequestSort('machineId')}
                                        >
                                            ID
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <TableSortLabel
                                            active={orderBy === 'type'}
                                            direction={orderBy === 'type' ? order : 'asc'}
                                            onClick={() => handleRequestSort('type')}
                                        >
                                            Tipo
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <TableSortLabel
                                            active={orderBy === 'brand'}
                                            direction={orderBy === 'brand' ? order : 'asc'}
                                            onClick={() => handleRequestSort('brand')}
                                        >
                                            Marca
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <TableSortLabel
                                            active={orderBy === 'modelo'}
                                            direction={orderBy === 'modelo' ? order : 'asc'}
                                            onClick={() => handleRequestSort('modelo')}
                                        >
                                            Modelo
                                        </TableSortLabel>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Imagen</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>Acciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {stableSort(machines, getComparator(order, orderBy))
                                    .map((machine, i) => (
                                        <TableRow key={i} hover>
                                            <TableCell>{machine.machineId}</TableCell>
                                            <TableCell>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: machine.typeId ? 'inherit' : 'error.main',
                                                        fontWeight: machine.typeId ? 'normal' : 'bold'
                                                    }}
                                                >
                                                    {machine.type?.toUpperCase() || 'SIN TIPO'}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>{machine.brand?.toUpperCase() || 'SIN MARCA'}</TableCell>
                                            <TableCell>{(machine.modelo || machine.model)?.toUpperCase() || 'SIN MODELO'}</TableCell>
                                            <TableCell>
                                                {machine.image?.data?.includes('image') ? (
                                                    <Box component="img" src={`data:${machine.image.data}`} sx={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 1 }} />
                                                ) : (machine.urlImagen || machine.urlimage) ? (
                                                    <Box component="img" src={machine.urlImagen || machine.urlimage} sx={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 1 }} />
                                                ) : (
                                                    imagenesGenericasOfLine?.[0] && (
                                                        <Box component="img" src={`data:${imagenesGenericasOfLine[0].pathBase64}`} sx={{ width: 60, height: 60, objectFit: 'cover', borderRadius: '50%' }} />
                                                    )
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={1} justifyContent="center">
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={() => abrirEditarMaquina(machine)}
                                                        sx={{ textTransform: 'none' }}
                                                    >
                                                        Editar
                                                    </Button>
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => handleDelete(machine)}
                                                        sx={{ textTransform: 'none' }}
                                                    >
                                                        Borrar
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                {/* Secondary Content: Management Lists */}
                <Grid item xs={12} lg={5}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={() => {
                                    setOpen(true)
                                    setIsEdit(false)
                                }}
                                sx={{
                                    bgcolor: '#333',
                                    '&:hover': { bgcolor: '#555' },
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    py: 1,
                                    fontWeight: 'bold'
                                }}
                            >
                                + Crear Nueva Máquina
                            </Button>
                        </Grid>
                        {/* Tipos */}
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={1} sx={{ p: 1.5, height: '240px', display: 'flex', flexDirection: 'column', borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Tipos de Máquinas</Typography>
                                <Divider sx={{ mb: 1 }} />
                                <Box id="tiposMaquinas" sx={{ flexGrow: 1, overflowY: 'auto', mb: 1 }}>
                                    {tipoMaquinas.map((machine, i) => (
                                        <Typography key={i} variant="caption" display="block" sx={{ p: 0.3, borderBottom: '1px solid #eee' }}>
                                            {machine.tipo}
                                        </Typography>
                                    ))}
                                </Box>
                                <Stack direction="row" spacing={0.5}>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        placeholder="Nuevo tipo"
                                        value={nuevoTipoMaquina}
                                        onChange={(e) => setNuevoTipoMaquina(e.target.value)}
                                        inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
                                    />
                                    <Button variant="contained" onClick={nuevoTipo} size="small" sx={{ fontSize: 11, minWidth: 'fit-content' }}>Ok</Button>
                                </Stack>
                            </Paper>
                        </Grid>

                        {/* Marcas */}
                        <Grid item xs={12} sm={6}>
                            <Paper elevation={1} sx={{ p: 1.5, height: '240px', display: 'flex', flexDirection: 'column', borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Marcas de Máquinas</Typography>
                                <Divider sx={{ mb: 1 }} />
                                <Box id="marcasMaquinas" sx={{ flexGrow: 1, overflowY: 'auto', mb: 1 }}>
                                    {marcasMaquinas.map((marca, i) => (
                                        <Typography key={i} variant="caption" display="block" sx={{ p: 0.3, borderBottom: '1px solid #eee' }}>
                                            {marca.marca}
                                        </Typography>
                                    ))}
                                </Box>
                                <Stack direction="row" spacing={0.5}>
                                    <TextField
                                        size="small"
                                        fullWidth
                                        placeholder="Nueva marca"
                                        value={nuevaMarcaMaquina}
                                        onChange={(e) => setNuevaMarcaMaquina(e.target.value)}
                                        inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
                                    />
                                    <Button variant="contained" onClick={nuevaMarca} size="small" sx={{ fontSize: 11, minWidth: 'fit-content' }}>Ok</Button>
                                </Stack>
                            </Paper>
                        </Grid>

                        {/* Modelos */}
                        <Grid item xs={12}>
                            <Paper elevation={1} sx={{ p: 1.5, height: 'calc(100vh - 460px)', minHeight: '300px', display: 'flex', flexDirection: 'column', borderRadius: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>Modelos de Máquinas</Typography>
                                <Divider sx={{ mb: 1 }} />
                                <Box id="modelosMaquinas" sx={{ flexGrow: 1, overflowY: 'auto', mb: 1 }}>
                                    <Grid container sx={{ position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1, pb: 0.5 }}>
                                        <Grid item xs={6}><Typography variant="caption" sx={{ fontWeight: 'bold' }}>Modelo</Typography></Grid>
                                        <Grid item xs={6}><Typography variant="caption" sx={{ fontWeight: 'bold' }}>Marca</Typography></Grid>
                                    </Grid>
                                    {modelosMaquinas.map((modelo, i) => (
                                        <Grid container key={i} sx={{ py: 0.3, borderBottom: '1px solid #eee' }}>
                                            <Grid item xs={6}><Typography variant="caption">{modelo.modelo || modelo.name}</Typography></Grid>
                                            <Grid item xs={6}><Typography variant="caption">{modelo.marca?.marca || modelo.marca?.name || 'N/A'}</Typography></Grid>
                                        </Grid>
                                    ))}
                                </Box>
                                <Stack spacing={1} sx={{ mt: 1 }}>
                                    <Stack direction="row" spacing={1}>
                                        <TextField
                                            size="small"
                                            fullWidth
                                            placeholder="Nuevo modelo"
                                            value={nuevoModeloMaqina}
                                            onChange={(e) => setNuevoModeloMaquina(e.target.value.toUpperCase())}
                                            inputProps={{ style: { fontSize: 12, padding: '6px 8px' } }}
                                        />
                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                            <InputLabel sx={{ fontSize: 12 }}>Marca</InputLabel>
                                            <Select
                                                value={nuevoModeloMarcaMaqina}
                                                label="Marca"
                                                onChange={(e) => setNuevoModeloMarcaMaquina(e.target.value)}
                                                sx={{ fontSize: 12 }}
                                            >
                                                <MenuItem value="" sx={{ fontSize: 12 }}><em>Seleccione una marca</em></MenuItem>
                                                {marcasMaquinas.map((marca, i) => (
                                                    <MenuItem key={i} value={marca._id} sx={{ fontSize: 12 }}>{marca.marca}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Stack>
                                    <Button variant="contained" onClick={nuevoModelo} fullWidth size="small" sx={{ textTransform: 'none' }}>Agregar Modelo</Button>
                                </Stack>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {assignDialogOpen && (
                <AssignTypeDialog
                    open={assignDialogOpen}
                    close={closeAssignDialog}
                    unassignedMachines={machinesOfProject.filter(m => !m.typeId)}
                    tipoMaquinas={tipoMaquinas}
                    modelosMaquinas={modelosMaquinas}
                    marcasMaquinas={marcasMaquinas}
                    onSave={handleAsignarTipoMaquina}
                />
            )}
            {open && (
                <NuevaMaquinaDialog
                    open={open}
                    close={onClose}
                    isEdit={isEdit}
                    maquinaParEditar={maquinaParEditar}
                    nuevaMaquina={handleNuevaMaquina}
                    editarMaquina={handleEditarMaquina}
                    asignarTipoMaquina={handleAsignarTipoMaquina}
                    marcasMaquinas={marcasMaquinas}
                    tipoMaquinas={tipoMaquinas}
                    modelosMaquinas={modelosMaquinas}
                />
            )}
            <GenerationStatusModal />
        </Box>
    )
}

export default MachinesAdminPage
